import { getUserName } from 'src/data/user';
import { usePopoverAnchor } from 'src/lib/hooks';
import {
  useCurrentCustomer,
  useCurrentCustomers,
  useCurrentUser,
  useIsCurrentUserAdmin,
  useIsSuperAdminUser,
} from 'src/store';
import {
  useCustomerUserReportExportEnabled,
  useCustomerUserReportViewEnabled,
} from 'src/store/customer';

import { LogoutPopup } from './LogoutPopup';
import { ProfileButton } from './ProfileButton';
import { ProfileMenu } from './ProfileMenu';
import { useCurrentPlanLabel } from './useCurrentPlanLabel';
import { useHandlers } from './useHandlers';
import useStyles from './useStyles';

export const UserProfile = ({ classes, disabledSettings }) => {
  const styles = useStyles({ classes });
  const [menuAnchor, openMenu, closeMenu] = usePopoverAnchor();
  const currentCustomers = useCurrentCustomers();
  const currentCustomer = useCurrentCustomer();
  const user = useCurrentUser();
  const planLabel = useCurrentPlanLabel();
  const userName = getUserName(user);
  const isReportExportEnabled = useCustomerUserReportExportEnabled();
  const isReportViewEnabled = useCustomerUserReportViewEnabled();
  const isAdmin = useIsCurrentUserAdmin();
  const isSuperAdmin = useIsSuperAdminUser();
  const showUsageDashboard = isSuperAdmin || (isAdmin && isReportViewEnabled);
  const showExportOnly = !showUsageDashboard && isAdmin && isReportExportEnabled;
  const {
    dialogLogoutOpened,
    closeLogoutDialog,
    handleCustomerClick,
    handleSettingsClick,
    handleUsageDashboardClick,
    handleEditClick,
    handleLogoutClick,
    handleLogout,
    handleProfileButtonClick,
  } = useHandlers({ openMenu, closeMenu });

  return (
    <>
      <ProfileButton
        open={!!menuAnchor}
        onClick={handleProfileButtonClick}
        name={userName}
        email={user?.email}
        planLabel={planLabel}
      />

      <ProfileMenu
        classes={{ paper: styles.menu_paper }}
        open={!!menuAnchor}
        anchor={menuAnchor}
        onClose={closeMenu}
        customers={currentCustomers}
        selectedCustomerId={currentCustomer && currentCustomer.id}
        onCustomerClick={handleCustomerClick}
        onSettingsClick={handleSettingsClick}
        onUsageDashboardClick={handleUsageDashboardClick}
        showUsageDashboard={showUsageDashboard}
        showExportOnly={showExportOnly}
        onLogoutClick={handleLogoutClick}
        onEditClick={handleEditClick}
        disabledSettings={disabledSettings}
        name={userName}
        email={user?.email}
      />

      <LogoutPopup
        open={dialogLogoutOpened}
        onApprove={handleLogout}
        onReject={closeLogoutDialog}
      />
    </>
  );
};
